<template lang="html">
    <div class="content">

        <section v-if="article === 'quantum-mechanica'" >
            <div class="image image-quantum-mechanics"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Quantum Mechanica </h1>

                    <p>
                        De laatste tijd verdiep ik mij in quantum mechanica.<br /><br /> Waarom?<br /><br />Geen idee.<br /><br /> Ik ben gewoon
nieuwsgierig. Als ik de uitleg probeer te volgen die wetenschappers geven in hun lezingen dan valt
mij op dat quantum mechanica iets moeilijks is. <br /><br />Althans, de sprekers trekken een aandachtig publiek
van mensen die er niet dom uit zien, maar desondanks de indruk geven geen idee te hebben waar ze
nu precies naar luisteren. <br /><br />De college-gevende wetenschappers zeggen geen sluitende theorie te
kunnen ontwikkelen voor de verschijnselen die ze ontdekken... <br /><br />Op de &eacute;&eacute;n of andere manier vind ik
dat grappig. <br /><br />Want het idee dat ‘de werkelijkheid’ niet in een eenduidige theorie is vast te leggen,
vind ik een fantastische vaststelling.
                    </p>

                    <p>
                        Hierin schuilt iets moois.
Hierin schuilt vrijheid.
Ook geestelijke vrijheid...

<br /><br />

En wat vind ik hier nu mooi aan? <br /><br />
                    </p>

                </div>
                <div class="f-1">

                    <h1>&nbsp;</h1>

                    <p>
                        Welnu, de verbijstering van de onderzoekers!<br /><br /> Die zijn opgegroeid
met het idee: “Meten is weten” en met het idee van tijd en ruimte. Terwijl hetgeen zij onder&shy;zoeken
niet is te meten, en geen rekening houdt met tijd en ruimte. <br /><br />Zo blijkt een deeltje direct invloed uit te
kunnen oefenen op een deeltje aan het andere eind van ons universum. Zonder dat er sprake is van
een tijds&shy;spanne om informatie van het ene deeltje naar het andere deeltje over te brengen. <br /><br />Het
gebeurt! <br /><br />En waarom? <br /><br />Geen idee. <br /><br /><br />En zo komen wetenschappers tot de conclusie dat de onderzoeker
niet verder komt dan een beeld ver&shy;krijgen van een niet bestaande werkelijkheid. <br /><br />Ik vind het
fantastisch omdat uiteindelijk de wer&shy;kelijkheid aan de greep van de mens ontglipt. <br /><br />Ik ben daarover
zelfs opgelucht.
                    </p>

                    <p>
                        Ik ben zo vrij dit te vertalen naar mijn eigen werkelijkheid. <br /><br /></p><hr class="special" /><p>Ik heb de neiging om mensen in te delen in
hokjes. <br /><br />Mijn basisvraag als ik naar mensen kijk is: “Deugt deze persoon wel of niet?”<br /><br />
Daarbij heb ik nog wel andere indelingen. Zo kan ik mensen mooi of lelijk vinden. <br /><br />Het blijkt dat ik in
minder dan een halve seconde mijn medemens heb ingedeeld in verschillende hokjes. </p><hr class="special" /><p>Het leuke
van de quantum mechanica vind ik de tik die ik krijg op mijn vingers, namelijk: mijn kijk op de
mede&shy;mens is niet meer dan de reflectie van mijn innerlijke spiegel. <br /><br />Mijn medemens is meer dan
hetgeen ik kan zien. <br /><br />De werkelijke Hij (of Zij) ontsnapt aan mijn waar&shy;neming.<br /><br />
De werkelijkheid stroomt. We willen het grijpen, vast&shy;leggen. Zoals een mooie foto aan de muur. Een
foto die verwijst naar de werkelijkheid (dat dan weer wel, maar niet meer dan dat).
<br /><br />We leven in een geheim... <br /><br />Lang leve het mysterie!
                    </p>

                </div>
            </div>
            <p class="quote">"... as long as no one is watching, anything goes." <span class="author">~ Lawrence M. Krauss </span></p>
        </section>

        <!-- <section v-if="article === 'de-reiger-en-corona'" >
            <div class="image image-reiger"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> De Reiger en Corona </h1>

                    <p>
                        Reiger heeft een mailbericht gekregen.<br />
                        Geen telefoontje of app,<br />
                        maar een mailbericht.<br />
                        Met een opdracht.<br />
                        Spannend!<br />
                        Spannend?<br />
                        Huh, stuur een gedicht!<br />
                        Stuur een gedicht?<br />
                        Moet dat nu, moet dat vandaag?<br />
                        Reiger zit midden in een verhuizing van de ene sloot naar de andere.<br />
                        en dan is er nog iets met Corina of Corona...<br />
                        Allemaal relatieproblemen lijken dat te zijn.<br />
                        Afstand houden.<br />
                        Geen bezoek.<br />
                    </p>

                    <p>
                        Reiger denkt na.<br />
                        Dat doe hij statig. Hij gaat er zelfs op een poot van staan, met een vleugelveertje omhoog.<br />
                        Dat staat deftig.<br />
                        Reiger wil graag deftig zijn.<br />
                        Liefst in grijs en blauw.<br />
                        Zijn er ook gedichten in grijs en blauw?<br />
                        Gedichten waar de wind doorheen waait?<br />
                        Waar het water doorheen stroomt?<br />
                        Dat is bekend terrein voor een reiger.<br />
                        Zoiets moet te doen zijn...<br />
                    </p>

                </div>
                <div class="f-1">

                    <h1>&nbsp;</h1>

                    <p>
                        Reiger denkt na.<br />
                        De wind moet waaien, het water moet stromen,<br />
                        Dat zal wel lukken.<br />
                        Maar een gedicht dat rijmt?<br />
                        Dat is wat veel gevraagd aan een reiger.<br />
                        Hoewel, reiger leest gedichten die helemaal niet rijmen.<br />
                        Maar dat vindt reiger niet in orde.<br />
                        Dat zijn verdwaalde gedichten.<br />
                        Die zijn van het padje af.<br />
                        Zoals veel mensen.<br />
                    </p>

                    <p>
                        Het hoofd is op hol. <br />
                        De draad is kwijt. <br />
                    </p>

                    <p>
                        Dood hoort bij het leven.<br />
                        Omwenteling.<br />
                        Reincarnatie.<br />
                        Reiger weet er alles van.<br />
                        Kikkers, mollen, muizen, vissen,<br />
                        gaan door zijn dood heen en komen in hem tot een nieuw leven.<br />
                        Een leven als reiger.<br />
                    </p>

                    <p>
                        Corina.<br />
                        Corona.<br />
                        Omwenteling.<br />
                        Revolutie.<br />
                        Door de dood heen een nieuw leven.<br />
                        Voor reiger is dit even te veel.<br />
                        Maar het is lente.<br />
                        Daarna een nieuwe zomer.<br />
                    </p>

                </div>
            </div>
            <p class="quote">"Life always waits for some crisis to occur before revealing itself at its most brilliant." <span class="author">~ Paulo Coelho </span></p>
        </section> -->

        <section v-if="article === 'singularity'" >
            <div class="image image-singularity"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Singulariteit </h1>

                    <p> Singulariteit valt te omschrijven als: "een toekomstig breekpunt wanneer de technologische vooruitgang zo snel gaat dat mensen met hun tegenwoordige in&shy;telligentie de maatschappij niet meer kunnen be&shy;grijpen". </p>

                    <p> Die verandering wordt in gang gezet door kunst&shy;matige intelligenties of "posthumans" (dat is een persoon of wezen dat boven het menselijke uitstijgt). </p>

                    <p> Het idee is dat de kunstmatige intelligenties of de posthumans zichzelf in hoog tempo blijven ver&shy;beteren. </p>

                </div>
                <div class="f-1">

                    <h1>&nbsp;</h1>

                    <p> Zo snel zelfs dat ze ons (mensen) op een gegeven moment voorbijstreven. </p>

                    <p> In de nabije toekomst – zo is de verwachting – zal dit leiden tot een fusie tussen mens en machine. </p>

                    <p> Levenden worden onsterfelijk en doden worden opgewekt. </p>

                    <p> Luister naar de profeten en schriftgeleerden uit Silicon Valley. In plaats van onszelf te verheffen, creëren we Google, Apple en Amazon, die ons zullen domineren. </p>

                    <p> Hoe kijkt u hier tegen aan? </p>

                </div>
            </div>
            <p class="quote">"It is not the strongest or the most intelligent who will survive but those who can best manage change." <span class="author">~ Leon C. Megginson </span></p>
        </section>

        <section v-if="article === 'doe-niet-mee'" >
            <div class="image image-lao-tse"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Ik maak mij zorgen, </h1>
                    <p>Ik lees, hoor en zie dat drugscriminelen zich invreten in onze samenleving. (Ik kan het ook hebben over mijn andere zorgen zoals de vernietiging van het regenwoud, de opwarming van de aarde, de behandeling van varkentjes enz…).</p>
                    <h1>Ik heb daar een mening over</h1>
                    <p>Ik heb daar een mening over en natuurlijk ook een oplossing. “We zijn doorgeslagen. Niemand grijpt in. Het moet worden aangepakt.” En ik denk: “Er moet iets gebeuren! Iemand moet opstaan. Die van wanten weet en doortastend is. Zeg maar: een sterke leider.” ... Ik zal die persoon niet zijn. En stel vast dat sterke leiders veel ellende brengen met hun oplossingen.</p>
                    <h1>Hoe dan wel?</h1>
                    <p>Ikzelf bestrijd niets. Want ik ben een bang mens.
En kom tot de veilige opvatting dat een ieder leeft met zijn of haar zijn eigen waarheid.
Een prachtig uitgangspunt voor een vrijmetselaar, want dat ben ik.
Daarnaast ben ik een gelukkig mens in mijn gezin, met de buren, in mijn sociale netwerk en met mijn
broeders in de loge.
Ik spreek mijzelf toe dat ik het daarbij moet houden.</p>
<h1>Maar er schuurt iets</h1>
<p>In mij schuilt verzet en een gezonde boosheid.</p>
<h1>Waar sta ik nu?</h1>
<p>Ik dwing mijzelf te stoppen met het bestrijden van ‘het kwaad’ en komt tot het besef dat ik als bang
mens een sterk wapen heb. Namelijk: Doe niet mee! Dat is iets anders dan de simpele vaststelling
dat iedereen zijn eigen waarheid heeft. Het reikt verder. Het is mijn zachte wapen. Niemand verplicht
mij mee te doen. Hiermee herneem ik mijn eigenheid.
Dat is mijn besluit. Ik voel me een held. Op mijzelf komt het aan. Roemloos, weinig meeslepend. Saai
in uw ogen wellicht. Maar wel vrij. En u?</p>
                </div>
                <div class="f-1">
                    &nbsp;
                </div>
            </div>
            <p class="quote">"Als je troebel water met rust laat, wordt het vanzelf helder." <span class="author">~ Lao-Tse </span></p>
        </section>

        <section v-if="article === 'oplopende-gemoederen'" >
            <div class="image image-puigdemont"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Oplopende gemoederen </h1>
                    <p>Waar ligt de grens tussen jezelf zijn en onderdeel zijn van een groter geheel? De grens tussen zorg dragen voor elkaar of enkel voor jezelf? Tussen liefde voor je eigen cultuur en het afzetten tegen andere? Het zijn vraagstukken die al leven zolang er gemeenschappen bestaan.</p>
                    <p>In Catalonië en Madrid lopen de gemoederen hoog op. Puigdemont heeft asiel aangevraagd in Brussel. Het is te hopen dat de EU hierin kan bemiddelen en de harmonie terugkeert op het Iberisch schiereiland.</p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>Misschien moeten we ons afvragen wat het betekent om Amsterdammer te zijn, Nederlander, Europeaan, wereldburger. Als vrijmetselaar zoeken we naar wat verbindt.</p>
                    <p>Samenwerking is de beste manier om conflict te voorkomen. Bij conflict is het verstandig om in alle openheid de problemen te benoemen en te bespreken. Doe elkaar recht en zoek oplossingen die in de toekomst houdbaar zijn.</p>
                    <p>Wellicht is deze complexe situatie in Spanje een kans voor Brussel om hierin het goede voorbeeld te geven.</p>
                </div>
            </div>
            <p class="quote">"De toekomst behoort aan hen die geloven in de schoonheid van hun dromen." <span class="author">~ E. Roosevelt </span></p>
        </section>

        <section v-if="article === 'de-poortwachter'" >
            <div class="image image-poortwachter"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Kun je zomaar lid worden van de Vrijmetselarij? </h1>
                    <p>
                        Voor de Wet staat een poortwachter. Bij deze poortwachter komt een man van het platteland toegang vragen tot de Wet. Maar de poortwachter zegt dat hij hem nu geen toegang kan verlenen. De man denkt na en vraagt dan, of hij dus later wel naar binnen mag. ‘Dat is mogelijk,’ zegt de poortwachter, ‘maar nu niet.’
                    </p>
                    <p>
                        Omdat de poort naar de Wet zoals altijd open staat en de poortwachter opzij stapt, bukt de man zich om door de poort naar binnen te kijken. Als de poortwachter dat ziet, lacht hij en zegt: ‘Als het je zo aantrekt, probeer dan toch ondanks mijn verbod naar binnen te gaan. Maar denk erom: ik ben machtig. En ik ben maar de laagste poortwachter. Bij alle zalen staan weer poortwachters, die steeds machtiger zijn. Van de derde kan ik de aanblik al niet meer verdragen.’
                    </p>
                    <p>
                        Zulke problemen heeft de man van het platteland niet verwacht; de Wet moet toch altijd en voor iedereen toegankelijk zijn, denkt hij, maar als hij nu aandachtiger naar de poortwachter met zijn bontjas kijkt, zijn grote puntneus, zijn lange, dunne, zwarte tartarenbaard, besluit hij toch liever te wachten tot hij toestemming krijgt om naar binnen te gaan. De poortwachter geeft hem een krukje en laat hem terzijde van de poort gaan zitten.
                    </p>
                    <p>
                        Daar zit hij dag in dag uit, jaar in jaar uit. Hij doet veel pogingen om toegelaten te worden en vermoeit de poortwachter met zijn verzoeken. De poortwachter onderwerpt hem vaak aan kleine verhoren, hoort hem uit over zijn geboortestreek en veel andere zaken, het zijn echter ongeïnteresseerde vragen zoals hoge heren ze stellen, en ten slotte zegt hij steeds weer tegen hem dat hij hem nog niet kan binnenlaten.
                    </p>
                    <p>
                        De man, die zich voor zijn reis met veel dingen heeft uitgerust, gebruikt alles, hoe waardevol het ook is, om de poortwachter om te kopen. Deze neemt wel alles aan, maar zegt erbij: ‘Ik neem het alleen aan om jou niet te laten denken dat je iets achterwege hebt gelaten.’ Gedurende die vele jaren observeert de man de poortwachter vrijwel onafgebroken. Hij vergeet de andere poortwachters en deze eerste lijkt hem het enige beletsel om de Wet binnen te gaan.
                    </p>
                </div>
                <div class="f-1">
                    <p>
                        Hij vervloekt het ongelukkige toeval, de eerste jaren ongegeneerd en luid, later, als hij oud wordt, bromt hij nog maar wat voor zich uit. Hij wordt kinds en omdat hij door het jarenlang bestuderen van de poortwachter ook de vlooien in zijn bontkraag heeft opgemerkt, vraagt hij ook de vlooien hem te helpen de poortwachter op andere gedachten te brengen. Ten slotte verzwakt zijn gezichtsvermogen en hij weet niet of het werkelijk donkerder wordt om hem heen, of dat zijn ogen hem alleen bedriegen.
                    </p>
                    <p>
                        Wel merkt hij echter nu in het donker een lichtglans op, die onafgebroken uit de poort van de Wet schijnt. Nu leeft hij niet lang meer. Voor zijn dood verzamelen zich in zijn hoofd alle ervaringen van die hele tijd in een vraag die hij tot nog toe niet aan de poortwachter heeft gesteld. Hij wenkt hem, omdat hij zijn verstijvend lichaam niet meer kan oprichten. De poortwachter moet diep naar hem overbuigen, want het verschil in grootte is zeer ten nadele van de man veranderd.
                    </p>
                    <p>
                        ‘Wat wil je nu toch nog weten?’ vraagt de poortwachter, ‘je bent onverzadigbaar.’ ‘Alle mensen streven er toch naar de Wet te bereiken,’ zegt de man, ‘hoe komt het dan dat al deze jaren niemand behalve ik toegang heeft gevraagd?’ De poortwachter merkt dat het einde van de man al is gekomen, en om zijn versagend gehoor nog te bereiken brult hij tegen hem: ‘Hier kon niemand anders toegang krijgen, want deze ingang was alleen voor jou bestemd. Ik ga hem nu afsluiten.’
                    </p>
                </div>
            </div>
            <p class="quote">"You shall not pass!" <span class="author">~ Gandalf </span></p>
        </section>

        <section v-if="article === 'boosheid'" >
            <div class="image image-boosheid"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Waarom toch al die boosheid?! </h1>
                    <p>Boosheid blokkeert communicatie. Wil je iets bereiken als je boos bent? Probeer dan voor je zelf te achter&shy;halen waar die boosheid vandaan komt. Probeer je boosheid te erkennen, en te omarmen, en de diepere oor&shy;zaak ervan te begrijpen. </p>
                    <p>Wij weten dat de oorzaken van boosheid niet buiten onszelf liggen, maar gevonden kunnen worden in onze verkeerde waarneming en gebrek aan begrip in onszelf en de ander. Maar dat gaat natuurlijk niet in een keer. </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>We zullen met de juiste toewijding moeten oefenen, zodat we ons vermogen tot begrip, liefde, vreugde en volledige acceptatie kunnen voeden. </p>
                    <p>Neem je, als boosheid in je opkomt, eens voor om niets te zeggen of te doen. Dat is een eerste stap. </p>
                    <p>Bij&shy;voorbeeld door je te richten op je ademhaling of door ouderwets tot 10 te tellen. </p>
                </div>
            </div>
            <p class="quote">"Elke minuut boosheid kost je zestig seconden geluk." <span class="author">~ R.W. Emerson </span></p>
        </section>

        <section v-if="article === 'vrijheid-van-denken'" >
            <div class="image image-vrijheid"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Vrijheid van denken </h1>
                    <p>
                        Opvattingen opdringen aan anderen.., dat werkt niet.
                    </p>
                    <p>
                        Daarom blijven we vastbesloten om niemand te dwingen, zelfs onze kinderen niet, onze opvattingen aan te nemen.
                    </p>
                    <p>
                        Mensen die dreigen, omkopen, manipuleren, staan voor propaganda en indoctrinatie. Ze nemen een loopje met de werkelijkheid en leggen anderen hun opvattingen op.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        Wij zullen het recht van anderen om anders te zijn respecteren, evenals hun recht zelf te bepalen wat ze willen geloven en welke keuzes ze willen maken.
                    </p>
                    <p>
                        Hoezeer we het soms misschien ook eens, of on-eens zijn met de ander.
                    </p>
                    <p>
                        Middels dialoog en het delen van inzichten helpen we fanatisme en kortzichtigheid op te geven.
                    </p>
                </div>
            </div>
            <p class="quote">"Wat is vrijheid zonder wijsheid, en zonder deugd?" <span class="author">~ E. Burke </span></p>
        </section>

        <section v-if="article === 'openheid'" >
            <div class="image image-openheid"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Openheid </h1>
                    <p>
                        Bewust van het lijden veroorzaakt door fanatisme en onverdraagzaamheid, zijn wij vastbesloten geen en&shy;kele leerstelling, theorie of ideologie, te verheerlijken of ons eraan vast te klampen.
                    </p>
                    <p>
                        We willen leren onderricht te zien als een leidraad om ons begrip en mededogen te ontwikkelen, en niet als een leer om voor te vechten, te doden of te sterven.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        Wij weten dat fanatisme in zijn vele verschijnings&shy;vormen het gevolg is van dualistisch en discri&shy;mi&shy;nerend waarnemen.
                    </p>
                    <p>
                        We willen leren met openheid te zien en vanuit inzicht te handelen zodat we dogmatisme en geweld in ons&shy;zelf en in de wereld kunnen transformeren.
                    </p>
                </div>
            </div>
            <p class="quote">"... het enige wat ik had was eerlijkheid en openheid." <span class="author">~ A. Lorde </span></p>
        </section>

        <section v-if="article === 'zoektocht'" >
            <div class="image image-zoektocht"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Zoektocht </h1>
                    <p>
                        Het leven is een soort labyrint, noem het een friendly prison. Daar wil je liever uit omdat je je niet (helemaal) vrij voelt. Maar hoe doe je dat?
                    </p>
                    <p>
                        Daar moet je dus 'je weg in vinden'. Of je er zin in hebt of niet; zoeken is de aangewezen weg. Die zoektocht loont wel, want er is een oplossing.., de uitgang.
                    </p>
                    <p>
                        Om je weg naar de uitgang te vinden heb je werk&shy;tuigen nodig. Kompas, thermometer, barometer en wat niet al. Afhankelijk van de omstandigheden ge&shy;bruik je het ene of het andere werktuig. Jouw tak van sport en persoonlijke voorkeuren zijn daarbij zeker ook van belang. Nog belangrijker is misschien dat je die tocht in elk geval begint.
                    </p>
                    <p>
                        ‘Zoeken’ is oplettend om je heen kijken met de kennis die je hebt. Awareness.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        Vrijmetselarij kan fungeren als een soort van reis&shy;bureau voor ‘zoekers’. Vrijmetselarij biedt reizen aan in de vorm van eeuwenoude rituelen. Onderweg merk je wat er met je gebeurt. Hoe langer je reist, hoe meer je ervaart en ook wilt ervaren.
                    </p>
                    <p>
                        ‘Vinden’ is alles wat zich aanbiedt in een misschien on&shy;verwachte maar ten diepste gewenste vorm. Synchroniciteit.
                    </p>
                    <p>
                        Eigenlijk weten we allemaal wel wat we zoeken. Voeding voor onze ziel.
                    </p>
                    <p>
                        Kijk maar naar de natuur om je heen, naar bij&shy;voorbeeld de hommels en de bijen. Zij weten ook precies waar ze moeten zijn voor waar het om te doen is.
                    </p>
                </div>
            </div>
            <p class="quote">"Toen ik moe was van zoeken, leerde ik vinden." <span class="author">~ F. Nietzsche </span></p>
        </section>

        <section v-if="article === 'parels-voor-de-zwijnen'" >
            <div class="image image-parels"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1> Parels voor de zwijnen </h1>
                    <p>
                        Deze week trof een klaproos mij. Zij groeide tussen beton&shy;steen en asfalt. Ontdaan van alle blaadjes toon&shy;de deze klaproos haar schoonheid. Kaler en eenzamer kon het niet.
                    </p>
                    <p>
                        ‘Op U komt het aan’ wordt de Vrijmetselaar ingeprent.
                    </p>
                    <p>
                        En laat u – als vrijmetselaar – leiden door Kracht, Schoon&shy;heid en Wijsheid. Deze bloem getuigt van een fragiele vermetelheid en laat haar schoonheid zien. Maar is het wijs om op deze plek haar schoonheid te tonen ..?! Is zij niet als een parel voor de zwijnen?
                    </p>
                    <p>
                        Met haar tere schoonheid dwingt zij auto’s en fietsers om haar heen te rijden. Dagenlang staat ze daar. On&shy;afgesproken wordt er rekening met haar gehouden. Een stille kracht gaat van haar uit.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        Wat is het geheim van die kracht? Het lijkt of zij weet dat klaprozen hun schoonheid tonen waar je het niet verwacht.
                    </p>
                    <p>
                        Soms tref je klaprozen in ‘broederschap’ bijeen. In de klaproos ervaar ik iets wat ik in mijzelf en andere vrijmetselaren herken, om die reden heb ik me aangesloten bij Loge La Force.
                    </p>
                </div>
            </div>
            <p class="quote">"Alles heeft z'n schoonheid alleen ziet niet iedereen dat altijd." <span class="author">~ Confucius </span></p>
        </section>

        <section v-if="article === 'rol-van-rituelen'" >
            <div class="image image-rituelen"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>De rol van rituelen</h1>
                    <p>
                        Kunnen wij werkelijk begrijpen waarom we doen zoals we doen, en hoe de mensen om ons heen handelen. Kunnen wij werkelijk onszelf zo goed begrijpen dat wij vrij worden en weten hoe we een goed leven moeten leiden?
                    </p>
                    <p>
                        Moeten we daarvoor ons ware zelf leren kennen en lukt dat door naar binnen te kijken? En wat als blijkt dat we feitelijk rommelige wezens zijn in een grillige wereld. Dat we niet meer zijn dan mensen die maar wat aan rommelen in interactie met anderen die eveneens maar wat aan rommelen?
                    </p>
                    <p>
                        Ons ware zelf zal leiden tot vaststellingen zoals: ik ben nu eenmaal verlegen, of ik ben een driftig persoon. Ons ware zelf dan is dan niet meer dan een reeks reactiepatronen die goed of destructief kunnen zijn. Er is geen waarachtig zelf te vinden. Als we dat denken te vinden, dan is het waarschijnlijk narcisme.
                    </p>
                    <p>
                        Hoe kunnen we onze vastgeroeste patronen doorbreken en veranderen? Daarvoor gebruikt onze broederschap ritualen. De ritualen zijn bedoeld om onszelf te focussen op symbolen die een afspiegeling zijn van het leven om ons heen.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        De broeders vervullen door de jaren heen verschillende rollen in een rituaal. Door verschillende rollen in een rituaal te vervullen, worden de broeders gedwongen een ander perspectief in te nemen. Dat gedwongen andere perspectief dwingt ons te beseffen dat een zelfbeeld niet meer dan een beeld is. Je bent deelnemer in een spel. Als deelnemer streef je naar een goede uitvoering van het rituaal.
                    </p>
                    <p>
                        In zekere zin is dat hetzelfde in het profane leven. Een ieder vervult daarin zijn rol van vader, moeder, zoon, dochter, broer, zus, buurman, buurvrouw, werkgever, werknemer, collega,…
                    </p>
                    <p>
                        Valt u samen met de verschillende rollen die u vervult in uw leven (u bent vader en gedraagt zich als een vader), en streeft u in uw levensspel het goede na, dan ontstaat er schoonheid. Het begint te kloppen.
                    </p>
                    <p>
                        Het is zoals het moet zijn. Op die manier leert u zichzelf in relatie tot de ander, het beste kennen.
                    </p>
                </div>
            </div>
            <p class="quote">"Als een regel eenmaal is doorbroken, is er geen houden meer aan." <span class="author">~ F. Ponsard </span></p>
        </section>

        <section v-if="article === 'waar-de-vriendschap-woont'" >
            <div class="image image-vriendschap"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>Waar de vriendschap woont</h1>
                    <p>
                        Hoe zoet is ’t, waar de vriendschap woont?
                        <br />
                        Waar haai en haring zich vertoont.
                        <br />
                        Op amicalen voet,
                        <br />
                        de snoek de vorens respecteert,
                        <br />
                        en familiar, met hen verkeert.
                        <br />
                        Gelijk ‘m op aarde doet.
                    </p>
                    <p>
                        O laten wij, in onzen kring,
                        <br />
                        als menschen van verstand,
                        <br />
                        dan met elkaer en onderling,
                        <br />
                        ons hechten in een vriendschapsband.
                        <br />
                        Tot nut van de broederband.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                </div>
            </div>
            <p class="quote">"Een band van broederschap maakt alle mensen één." <span class="author">~ T. Carlyle </span></p>
        </section>

        <section v-if="article === 'oog-van-de-naald'" >
            <div class="image image-naald"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>Door het oog van de naald</h1>
                    <p>
                        Als kind durfde ik heel veel. Ik zocht vooral het on&shy;bekende. Mijn moeder hield me niet of nauwelijks in bedwang. Daar kwamen natuurlijk ongelukken van.
                    </p>
                    <p>
                        Mijn vader was ook niet gerust na twee of drie bijna-verdrinkingen. Toen op zevenjarige leeftijd mijn rech&shy;ter onderbeen net niet geamputeerd werd was de boot aan. Ik ging door het oog van de naald.
                    </p>
                    <p>
                        Hoe groot is zo’n oog eigenlijk en hoe vaak moet je daar als mens doorheen?
                    </p>
                    <p>
                        Als kind ben je een soort draad, meer nog een draad&shy;je. Die draad wordt al gauw een kabel en dat is ook wel nodig om het leven aan te kunnen. Maar een kabel gaat bij tegenvallers niet meer door het oog van een naald! Dan zijn er andere werktuigen nodig om je weg te vinden. Opvoeding en opleiding helpen wel, maar zijn niet genoeg. Hoe ga je van hieruit verder?
                    </p>
                    <p>
                        Vriendschap, religie, filosofie en wat is er nog meer? Wat laat je vallen, wat voeg je toe? Grabbelton dus en zoeken maar!
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        Het leven neemt door de dagelijkse beslommeringen doorgaans z’n eigen loop, vaak heel straight en daar valt niet zoveel tegen in te brengen. Toch zijn er on&shy;verwachte momenten, die een doorkijkje bieden naar elders. Naar opzij. Naar wat? Alsof de zon ineens door&shy;breekt, zo iets.
                    </p>
                    <p>
                        Zo’n moment kwam er voor mij gelukkig ook. In 1986 op een avond voor belangstellenden van de vrij&shy;metselarij in Amstelveen. Mijn toenmalige vriendin was daar wekelijks op yoga. “In de Tempel” zei ze, “je moet daar eens gaan kijken, typisch iets voor jou, net wat je zoekt”. Ze ging met me mee die avond. Haar ben ik daarna kwijt geraakt, de Loge La Force en heel veel meer heb ik gevonden. Ook de vrouw waar ik volgend jaar 25 jaar mee getrouwd ben.
                    </p>
                    <p>
                        Het was een mooie en bijzondere avond. De tafels waren opgesteld in een U-vorm. De inleider stond tegenover de U. Hij hield een boeiend verhaal, waar&shy;van de inhoud mij min of meer boven de pet ging. Ik rilde van de emoties.
                    </p>
                    <p>
                        Die emoties zijn er tot de dag van vandaag.
                    </p>
                </div>
            </div>
            <p class="quote">"Het geluk in uw leven hangt af van de aard uwer gedachten." <span class="author">~ M. Aurelius </span></p>
        </section>

        <section v-if="article === 'malende-molens'" >
            <div class="image image-molen"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>Malende molens</h1>
                    <p>
                        Rembrandt (1606-1669) was het negende kind (van tien) van molenaar Harmen van Rijn. Z’n moeder was de dochter van een voorname bakker. Z’n vader schreef hem in als student in Leiden. Zelf koos hij voor een loopbaan als kunstschilder. Zijn podium werd het exploderende Amsterdam van die jaren.
                    </p>
                    <p>
                        Molenaars zijn vanouds belangrijk, geliefd en on&shy;misbaar geweest. Ze hadden verstand van geld, ze maalden het graan, ze produceerden het meel en daar bakte de gemeenschap dan brood van. Waarom deze introductie over molenaars als ik iets over mijzelf wil vertellen? Welnu, mijn leven blijkt vol molenaars te zitten. Ik zal ze voor u op een rijtje zetten.
                    </p>
                    <p>
                        Kort na de oorlog huurden m’n ouders een kamer van ene familie Molenaar. En mijn vader was sinds 1945 vertegenwoordiger bij een grossier in levensmiddelen, oorspronkelijk een molenaarsfamilie. Mijn kleuterjuf (1950) heette Mulder, en de promotor bij mijn dis&shy;sertatie weer Molenaar (1972).
                    </p>
                    <p>
                        Mulder en Molenaar zijn of waren sinds 1991 enkele van mijn maçonnieke broeders. En… al meer dan tien jaar wonen wij inmiddels tegenover de in 1921 ge&shy;sloopte molen (oorsprong vóór 1500) aan het Moleneind, in Hilversum.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        In het geval van Rembrandt stel ik mij de volgende vraag. Spraken Hollandse molenaars omstreeks 1600 Diets of ook een beetje Duits? Niet onbelangrijk, want sommige woorden zijn voor meer uitleg vatbaar. Dat kan dan weer uitnodigen tot nieuwsgierigheid, na&shy;denken en mediteren… Rembrandt werd naar mijn idee kunstschilder (Maler) om te worden wie hij was.
                    </p>
                    <p>
                        Rembrandt gaf op die manier een mooi voorbeeld van ‘Ken u zelve’ dat een centraal begrip is binnen de vrij&shy;metselarij. De vrijmetselarij – waar ik lid van ben – heeft een traditie die vol zit met symbolen en ruimte en rust biedt aan het bijzondere proces van het leren kennen van jezelf. Ik heb daar tussen mijn broeders, in een vertrouwde omgeving, op mijn eigen wijze en in mijn eigen tempo mogen ‘worden’ wie ik eigenlijk al was.
                    </p>
                    <p>
                        Dit soort molens malen langzaam. Maar dat maakt niet uit… op die manier blijft wel het licht schijnen in mijn duisternis.
                    </p>
                </div>
            </div>
            <p class="quote">"Het vraagt moed om te groeien en te worden wie je diep van binnen bent." <span class="author">~ E.E. Cummings </span></p>
        </section>

        <section v-if="article === 'broederschap'" >
            <div class="image image-broederschap"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>Broederschap</h1>
                    <p>
                        In de kleuterklas bij juffrouw Mulder was het altijd feest. Wij knipten, plakten, kleurden en vlochten matjes. Ik maakte hele kunstwerken en die nam ik dan mee naar huis om aan m’n moeder te laten zien. Thuis waren we met z’n vieren: mijn ouders, een jongere zus en ik.
                    </p>
                    <p>
                        Schoolklassen zijn anders dan een gezin. Je komt daar om van alles te leren en vaardiger te worden. Dat is een goede zaak, het leven biedt immers vele uit&shy;dagingen. Op school leer je wie je vrienden zijn, maar je leert ook om te gaan met klasgenoten waar je het minder mee kunt vinden. Zo groei je op. Als alles goed gaat ontwikkel jij je tot iemand die tegen een stootje kan. Je kunt het leven aan.
                    </p>
                    <p>
                        Matjes vlechten is voor mij een metafoor geworden: matjes van mensen, een vlechtwerk van ver&shy;bondenheid. Het vlechtwerk kan eenvoudig of in&shy;gewikkeld zijn: horizontaal, verticaal of diagonaal.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>
                        Sommige matjes spreken mij meer aan dan andere. Werk bijvoorbeeld is zo’n matje. Vereniging en kerk trouwens ook.
                    </p>
                    <p>
                        Door persoonlijke ontwikkeling kan je voorkeur voor een bepaald matje veranderen. Je gaat op zoek naar nieuwe vormen.
                    </p>
                    <p>
                        Zo raakte ik op mijn veertigste geïnteresseerd in de Vrijmetselarij. Het heeft even geduurd, maar vijf jaar later werd ik lid van loge La Force. Een (h)echte broederschap, een serieuze en gezellige mannenclub met nieuwe patronen van geestelijke verdieping en sociale betrokkenheid.
                    </p>
                    <p>
                        Eeuwenoude patronen... en tussen de vlechtdraden van mijn broeders ook mijn eigen draad. Matjes die ik wekelijks mee naar huis neem, al 25 jaar...
                    </p>
                </div>
            </div>
            <p class="quote">"De sleutel tot inzicht bevindt zich in onszelf." <span class="author">~ T. Meng </span></p>
        </section>

        <section v-if="article === 'de-moderne-vrijmetselarij'" >
            <div class="image image-moderne-vrijmetselarij"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>De moderne Vrijmetselarij</h1>
                    <p>
                        Moderne Vrijmetselarij is een geestelijke stroming die ernaar streeft, weg te nemen wat mensen verdeelt en te zoeken naar wat hen tot elkaar brengt.
                    </p>
                    <p>
                        Steeds heeft zij getracht, die idealen uit te dragen en aan volgende generaties door te geven. Haar boodschap heeft nog niets aan betekenis verloren.
                    </p>
                    <p>
                        In de jachtige tijd van de 21e eeuw, vormt de Vrij&shy;metselarij een rustpunt voor verdieping en zingeving. Daarom zijn de volgende ‘oude grondslagen’ ook nu bijzonder relevant.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p>De grondslagen van de Vrijmetselarij zijn:</p>
                    <ul>
                        <li>Erkenning van de hoge waarde van de menselijke persoonlijkheid</li>
                        <li>Ieders recht om zelfstandig te zoeken naar waarheid</li>
                        <li>Verantwoordelijkheid voor het eigen doen en laten</li>
                        <li>Gelijkwaardigheid en het hebben van respect voor en met andersdenkenden</li>
                        <li>Broederschap</li>
                        <li>Werken aan het welzijn van de samenleving</li>
                    </ul>
                </div>
            </div>
            <p class="quote">"Liefde! Liefde! Dat is de ziel van het genie." <span class="author">~ W.A. Mozart </span></p>
        </section>

        <section v-if="article === 'lid-worden'" >
            <div class="image image-inwijding"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>Lid worden</h1>
                    <p>
                        Men moet 21 jaar oud en van het mannelijk geslacht zijn om vrijmetselaar te kunnen worden. Er is geen maximum leeftijd voor kandidaten. Een gemiddelde vrijmetselaarsloge in Nederland telt 35 leden die wekelijks bijeenkomen.
                    </p>
                    <p>
                        Als u lid wilt worden zult u als belangstellende zelf de eerste stap moeten zetten. Men wordt in principe niet voor het lidmaatschap van een loge gevraagd. Het kan natuurlijk wel voorkomen dat een vrijmetselaar iemand die hem geschikt lijkt, wijst op het bestaan van de Vrijmetselarij.
                    </p>
                    <p>
                        Nodig voor toetreding is dat je in een loge wordt voor&shy;gedragen door een Meester – Vrijmetselaar. Heeft u die in uw familie- of kennissenkring dan richt u zich waarschijnlijk tot hem; heeft u zo’n bekende niet dan wordt dat geregeld in overleg met de loge van uw keuze.
                    </p>
                    <p>
                        Een kandidaat-vrijmetselaar moet bekend staan als een goed, eerlijk en betrouw&shy;baar mens. Iemand zal zich in de loge in het algemeen weinig anders ge&shy;dragen dan in de samen&shy;leving.
                    </p>
                    <p>
                        Verder moet u blijk geven van een tolerante levens&shy;houding.
                    </p>
                </div>
                <div class="f-1">
                    <h1>&nbsp;</h1>
                    <p class="question">Hoe meld ik me aan?</p>
                    <p>Maak uw voornemen bekend door een email te sturen naar de loge van uw keuze.</p>
                    <p class="question">Wat gebeurt er daarna?</p>
                    <p>U wordt verzocht een vragenlijst in te vullen en een levensbeschrijving op te stellen.</p>
                    <p class="question">En dan ben ik lid?</p>
                    <p>Nee. Een Commissie van Onderzoek wordt ingesteld en behandelt uw aanvraag. De procedure omvat enkele persoonlijke gesprekken met verschillende broeders uit de Loge. Als uit deze gesprekken blijkt dat u geschikt geacht wordt lid te worden van  de loge ontvangt u na verloop van tijd een uit&shy;nodi&shy;ging voor uw inwijding.</p>
                    <p class="question">Hoe lang duurt de hele aanmeldings-procedure?</p>
                    <p>Over het algemeen neemt de procedure enkele maan&shy;den in beslag.</p>
                    <p class="question">Heeft u meer vragen?</p>
                    <p>Stuur ons een email via het email-adres op de informatie pagina.</p>
                </div>
            </div>
            <p class="quote">"Als je vertrouwen hebt, hoef je niet de hele<br /> trap te zien om de eerste stap te zetten." <span class="author">~ M.L. King </span></p>
        </section>

        <section v-if="article === 'symboliek'" >
            <div class="image image-symboliek"></div>
            <hr />
            <div class="f-c">
                <div class="f-1">
                    <h1>Symboliek</h1>
                    <p>
                        Het gebruik van symbolen is al zo oud als de mens&shy;heid zelf en we gebruiken symbolen vaak zonder ons er echt van bewust te zijn. We treffen symbolen aan in allerlei vormen. Soms als object zoals bij de trouwring, soms als een teken, zoals dat voor het hart of de euro en soms als een gebaar, bijvoorbeeld om aan te geven van we van iemand vinden of om andere gevoelens uit te drukken.
                    </p>
                    <p>
                        De vrijmetselarij bedient zich vooral van de bouwsymboliek en van die van het licht. Zo staat de winkelhaak in het logo van de vrijmetselarij voor “de rechte verhouding” (iets is wel of niet “in de haak”) en de witte handschoenen die de vrijmetselaar draagt, zijn vanwege zijn streven zijn arbeid en daden “zo zuiver mogelijk” te doen zijn.
                    </p>
                </div>
                <div class="f-1">
                    <h1>Ritualistiek</h1>
                    <p>
                        Symbolen winnen aanmerkelijk aan kracht als ze worden ingebed in een ritueel: een soort toneelspel waarin de symboliek wordt ingepast in het verhaal dat wordt uitgebeeld. Het woord ritueel roept vaak associaties op met iets van geheimzinnigheid of met dingen die zich vooral afspelen bij volkeren in verre vreemde landen. Maar ook van rituelen zijn talloze voorbeelden te vinden in onze directe omgeving. Niet alleen de mis in een kerk of een trouwpartij is zo’n ritueel maar ook de opening van de Staten Generaal of de kranslegging op de Dam kunnen als zodanig worden aangemerkt.
                    </p>
                    <p>
                        Vrijmetselaren bedienen zich dus van bouw- en lichtsymboliek ingebed in rituelen. In het intellectuele spel dat vrijmetselaren spelen bouwen zij symbolisch aan de tempel van Salomo. Zij zelf zijn daarbij de ruwe steen die in een continue proces bewerkt moet worden om te komen tot een (zuivere) kubiek die zo goed mogelijk past in de tempel van de samenleving.
                    </p>
                </div>
            </div>
            <p class="quote">"Een idee, in de meest zuivere betekenis, kan alleen<br />overgebracht worden door een symbool." <span class="author">~ S.T. Coleridge </span></p>
        </section>

        <div class="f-c">


            <div class="f-1">
                <AndereArtikelen></AndereArtikelen>
            </div>

            <div class="f-1">
                <Proceedings></Proceedings>
            </div>

        </div>

    </div>
</template>

<script>

import Proceedings from './Proceedings'
import AndereArtikelen from './AndereArtikelen'

export default {
    components: {
        Proceedings,
        AndereArtikelen
    },
    data: () => {
        return {
            article: ''
        }
    },
    mounted() {
        this.article = this.$route.params.id
        document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    watch: {
        '$route.params.id'() {
            this.article = this.$route.params.id
            document.body.scrollTop = document.documentElement.scrollTop = 0
        }
    }
}

</script>

<style lang="css" scoped>
    .image-puigdemont {
        background: transparent url('/images/puigdemont.jpeg') no-repeat center center;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-poortwachter {
        background: transparent url('/images/poortwachter.jpg') no-repeat center -130px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-boosheid {
        background: transparent url('/images/boosheid.jpg') no-repeat center -200px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-vrijheid {
        background: transparent url('/images/freedom.jpg') no-repeat center -20px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-openheid {
        background: transparent url('/images/openboek.jpg') no-repeat center -30px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-zoektocht {
        background: transparent url('/images/zoektocht.jpg') no-repeat center center;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-parels {
        background: transparent url('/images/parels.jpg') no-repeat center center;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-rituelen {
        background: transparent url('/images/rituelen.jpg') no-repeat center center;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-vriendschap {
        background: transparent url('/images/brothers2.jpg') no-repeat center -370px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-naald {
        background: transparent url('/images/needle.jpg') no-repeat center -60px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-molen {
        background: transparent url('/images/molen.jpg') no-repeat center -210px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-broederschap {
        background: transparent url('/images/vlechtwerk.png') no-repeat center center;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-moderne-vrijmetselarij {
        background: transparent url('/images/freimaurer.jpg') no-repeat center -445px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .f-1 ul {
        margin: 0;
        padding: 0 20px;
    }
    .f-1 ul li {
        font-size: 19px;
    }
    .image-inwijding {
        background: transparent url('/images/inwijding.jpeg') no-repeat center -140px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-symboliek {
        background: transparent url('/images/hand.jpg') no-repeat center -410px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-lao-tse {
        background: transparent url('/images/lao-tse.jpg') no-repeat center center;
        background-size: cover;
        min-height: 330px;
        margin-top: 30px;
    }
    .image-singularity {
        background: transparent url('/images/singularity.gif') no-repeat center center;
        background-size: cover;
        min-height: 330px;
        margin-top: 30px;
    }
    .image-reiger {
        background: transparent url('/images/heronn.png') no-repeat top center;
        background-size: cover;
        min-height: 330px;
        margin-top: 30px;
    }
    .image-quantum-mechanics {
        background: transparent url('/images/quantum-mechanics.png') no-repeat center bottom;
        background-size: cover;
        min-height: 300px;
        margin-top: 30px;
    }
</style>
